import { Party } from 'app/event/models/party';
import { FlashMessage } from './../../../shared/flash-messages/flash.message.record';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EventUtils } from 'app/event/utils/event-utils';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { Subscription } from 'rxjs/Subscription';
import { MenuStore } from '../../../menus/service/menu.store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { ResponseUtil } from '../../../shared/utils/response-util';
import { OnyxEvent } from '../../models/event';
import { Payment } from '../../models/payment';
import { ReportType } from '../../models/report-type.enum';
import { EventStore } from '../../service/event.store';
import { PaymentStore } from '../../service/payment.store';
import { ReportService } from '../../service/report.service';
import { OoivRulesStore } from 'app/event/service/ooiv-rules.store';
import { TaxDeterminationStore } from '../../service/tax-determination.store';
import { Unsubscriber } from './../../../shared/helper/unsubscriber';
import { Router } from '@angular/router';
import { ConfigLookupType } from '../../models/config/config-lookup-type';
import { GroupPayConfigStore } from '../../service/grouppay-config.store';
import { ConfigResponse } from '../../models/config/config-response';
import { VendorCommissionCardComponent } from '../vendor-commission-card/vendor-commission-card.component';

@Component({
  selector: 'pioneer-vendor-commission',
  templateUrl: './vendor-commission.component.html',
  styleUrls: ['./vendor-commission.component.css']
})
export class VendorCommissionComponent extends Unsubscriber implements OnInit {

  commissionForm: FormGroup;
  onyxEvent: OnyxEvent;
  eventParties: Party[] = [];
  latestPayment: Payment;
  ooivRulesValidation = true;
  ooivEntityReady = true;

  eventStatus: string;

  configLoaded = false;
  statusLoaded = false;

  openedCardIndex = 0;


  constructor(
    private formBuilder: FormBuilder,
    private menuStore: MenuStore,
    private eventStore: EventStore,
    private authenticationStore: AuthenticationStore,
    private flashMessagesService: FlashMessagesService,
    private translateService: TranslateService,
    private ooivRulesStore: OoivRulesStore,
    private taxDeterminationStore: TaxDeterminationStore,
    private router: Router,
    private groupPayConfigStore: GroupPayConfigStore
  ) {
    super();
    }

  ngOnInit() {

    this.addSubscription(
      this.eventStore.selectedEvent.subscribe((event: OnyxEvent) => {
        this.onyxEvent = new OnyxEvent(event);
        if (
          this.onyxEvent.eventVendors !== undefined &&
          this.onyxEvent.eventVendors.length < 5
        ) {
          this.onyxEvent.eventVendors[0].isExpanded = true;
        }

        this.eventParties = this.onyxEvent.eventVendors;

        this.addSubscription(
          this.eventStore
            .getEventStatus(this.onyxEvent.eventId)
            .subscribe((eventStatus: string) => {
              this.eventStatus = eventStatus;
              this.statusLoaded = true;
            },
            (err) => {
            },
            () => {
              this.statusLoaded = true;
            })
        );
      })
    );

    this.commissionForm = this.formBuilder.group({});
    if (this.onyxEvent && EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    } else {
      this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
    }

    this.addSubscription(this.ooivRulesStore.getAnyOoivExceptionRule()
      .subscribe(rule => {
        if (rule) {
          this.ooivRulesValidation = rule.ooivExceptionsIsValid;
        }

        if (this.ooivRulesValidation) {
          this.addSubscription(this.ooivRulesStore.getAgencyOoivExceptionRule().subscribe(agencyRule => {
            if (agencyRule) {
              this.ooivEntityReady = agencyRule.ooivExceptionsIsValid;
            }
          }));
        }
      }));

    if (!this.ooivRulesValidation) {
      // this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT',
      //   {'role': this.authenticationStore.isPropertyUser() ? 'Property' : 'Agency'}));
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT',
        {'role': 'Agency'}));
    }

    if (!this.ooivEntityReady) {
      this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ENROLLMENT_NOT_COMPLETED_PROMPT'));
    }

    this.addSubscription(this.taxDeterminationStore.getGlobalResponseTaxesList().subscribe((taxes) => {
      if (!taxes.isValidTax) {
        this.flashMessagesService.error(this.translateService.instant('EVENT.COMMISSION.PENDING_TAX_ESTIMATED_ERROR_MSG'));
      }
    }));

    this.addSubscription(this.flashMessagesService.closeMessageStream.subscribe((flashMessage: FlashMessage) => {
      if (flashMessage && flashMessage.message
          && flashMessage.message.includes('Unable to determine Tax. Please try again in few minutes.')) {
        this.router.navigate(['/event', this.onyxEvent.eventId, 'summary']);
      }
    }));


    let configRequests: any[] = [];
    this.onyxEvent.eventVendors.forEach((vendor) => {
      const request = {
        key: ConfigLookupType.PREPAYMENT_MIN_AMOUNT,
        chain: vendor.chain,
        brand: vendor.brand,
        propertyId: vendor.propertyId,
        agencyId: this.onyxEvent.eventAgency.code,
      };
      configRequests.push(request);
    });

    this.addSubscription(
      this.groupPayConfigStore
        .loadConfigBulk(configRequests, ConfigLookupType.PREPAYMENT_MIN_AMOUNT)
        .subscribe(
          (response: ConfigResponse[]) => {
            const configResponses = response;
            this.onyxEvent.eventVendors.forEach((vendor) => {
              vendor.config = configResponses.find(
                (x) => x.propertyId === vendor.propertyId
              );
            });
            this.configLoaded = true;
          },
          (err) => {
          },
          () => {
            this.configLoaded = true;
          }
        )
    );

  }

  trackVendorByFn(index: number, vendor: Party) {
    return vendor.eventPartyId;
  }

  onToggle(index: number, card: VendorCommissionCardComponent) {
    if (this.openedCardIndex === index) {
      // Toggling the card that was open. By setting the index to -1, all cards will be closed.
      this.openedCardIndex = -1;
    } else {
      // Open the vendor card in the provided index.
      this.openedCardIndex = index;

      // Scroll to the card
      setTimeout(() => {
        card.cardWrapper.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendor-commission/vendor-commission.component.ts